<template>
  <div>
    <section class="section ">
      <div class="level m-b-0">
        <div class="level-left">
          <div class="level-item">
            <p class="title is-5">Ledger Details for {{ companyName }}</p>
          </div>
        </div>

        <div class="level-right p-t-10">
          <div class="level-item" v-if="franchiseeTransaction.length">
            <button class="button is-link is-small" title="Print" @click="printLedger">
              <b-icon icon="printer" size="is-small" class="m-r-5"></b-icon>
              PRINT
            </button>
          </div>
          <div class="level-item" v-if="franchiseeTransaction.length">
            <button class="button is-link is-small" title="Export" @click="exportToCSV">
              <b-icon icon="download" size="is-small" class="m-r-5"></b-icon>
              EXPORT TO CSV
            </button>
          </div>
          <div class="level-item">
            <a class="button is-small is-link" title="Filter" @click="toggleFilter = true">
              <b-icon icon="filter" size="is-small"></b-icon>
            </a>
          </div>
          <div class="level-item">
            <router-link :to="{ name: 'ledger' }" class="button is-small is-link">Back to List </router-link>
          </div>
        </div>
      </div>
      <span v-if="franchiseeTransaction.companyName"> Company Name: {{ franchiseeTransaction.companyName || '' }}</span>
    </section>

    <!-- filter modal -->
    <div class="modal" :class="{ 'is-active': toggleFilter }">
      <div class="modal-background"></div>
      <form class="modal-card">
        <header class="modal-card-head">
          <p class="modal-card-title">Ledger Filter</p>
          <button class="delete" type="button" @click="toggleFilter = false"></button>
        </header>
        <section class="modal-card-body">
          <form @submit.prevent="getAllTransactions">
            <!-- <div class="columns">
              <div class="column">
                <div class="field">
                  <label class="label">Academic Year</label>
                  <div class="control">
                    <span class="select is-fullwidth">
                      <select name="sales" v-model="academicYearID" @change="getYearIn()">
                        <option :value="year.academicYear" selected v-for="year in allacademicYears" :key="year.id">{{ year.academicYear }}</option>
                      </select>
                    </span>
                  </div>
                </div>
              </div>
            </div> -->
            <div class="columns">
              <div class="column">
                <div class="field">
                  <label class="label">Start Date</label>
                  <div class="control">
                    <span class="select is-fullwidth">
                      <input class="input" v-model="fromDate" :min="minDate" :max="maxDate" type="date" />
                    </span>
                  </div>
                </div>
              </div>
              <div class="column">
                <div class="field">
                  <label class="label">End Date</label>
                  <div class="control">
                    <span class="select is-fullwidth">
                      <input class="input" v-model="toDate" :min="fromDate" :max="maxDate" type="date" />
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div class="columns form-row">
              <div class="column">
                <button class="button is-success is-pulled-right" type="submit">Apply</button>
              </div>
            </div>
          </form>
        </section>
      </form>
    </div>

    <iframe id="iframeLedger" name="iframeLedger" style="height:0;width:0;"></iframe>
    <section id="ledgerPrintableArea" style="margin-left:20px;margin-right:20px;">
      <div class="b-table">
        <table class="table is-bordered is-striped is-narrow is-hoverable is-fullwidth ledgerTable">
          <thead>
            <tr>
              <th style="width: 5%">Sr.No.</th>
              <th>Date</th>
              <th></th>
              <th style="width: 30%">Particulars</th>
              <th>Voucher Type</th>
              <th style="width: 12%"><span class="mdi mdi-currency-inr"></span> Debit</th>
              <th style="width: 12%"><span class="mdi mdi-currency-inr"></span> Credit</th>
            </tr>
          </thead>
          <tbody>
            <!-- <tr>
              <td></td>
              <td>
                <b>{{ currentFY }}</b>
              </td>
              <td class="has-text-centered">
                <b></b>
              </td>
              <td>
                <b>Opening Balance</b>
              </td>
              <td></td>
              <td class="has-text-right">
                <b> {{ startBalance !== null ? (startBalance.openingAmount.type === 'DEBIT' ? numberWithCommas(Number(startBalance.openingAmount.amount).toFixed(2)) : '0.00') : '0.00' }}</b>
              </td>
              <td class="has-text-right">
                <b> {{ startBalance !== null ? (startBalance.openingAmount.type === 'CREDIT' ? numberWithCommas(Number(startBalance.openingAmount.amount).toFixed(2)) : '0.00') : '0.00' }}</b>
              </td>
            </tr> -->

            <tr v-for="(ledger, index) in franchiseeTransaction" v-bind:key="index">
              <td>{{ index + 1 }}</td>
              <td>{{ ledger.accountApproveDate ? ledger.accountApproveDate : '-' }}</td>
              <td class="has-text-centered">{{ ledger.transactionType === 'CREDIT' ? 'Dr' : 'Cr' }}</td>
              <td>
                {{ ledger.transactionDescription }}
                <br />

                <router-link
                  v-if="ledger.order && ledger.order.kitType && ledger.moduleType === 'ORDER_KIT'"
                  :to="{ name: 'KitOrderDetails', params: { kitType: changeRouteName(ledger.order.kitType), orderID: ledger.order.orderID, franchiseeID: companyId } }"
                >
                  Order Details</router-link
                >
              </td>
              <td>{{ ledger.voucherType }}</td>
              <td class="has-text-right">
                {{ ledger.transactionType === 'DEBIT' ? numberWithCommas(ledger.amount) : '' }}
              </td>
              <td class="has-text-right">
                {{ ledger.transactionType === 'CREDIT' ? numberWithCommas(ledger.amount) : '' }}
              </td>
            </tr>
            <tr>
              <td colspan="6" class="has-text-right">
                <span class="mdi mdi-currency-inr"></span>
                {{ numberWithCommas(totalDebit) }}
              </td>
              <td class="has-text-right"><span class="mdi mdi-currency-inr"></span>{{ numberWithCommas(totalCredit) }}</td>
            </tr>
            <tr>
              <td colspan="3" class="has-text-right">
                {{ Number(this.totalCredit - this.totalDebit) > 0 ? 'Dr' : 'Cr' }}
              </td>
              <td>Closing Balance</td>
              <td colspan="2" class="has-text-right">
                <span class="mdi mdi-currency-inr"></span>
                {{ numberWithCommas(Number(ClosingBalance).toFixed(2)) }}
              </td>
              <td></td>
            </tr>
            <tr>
              <td colspan="6" class="has-text-right" v-if="finalDebit">
                <span class="mdi mdi-currency-inr"></span>

                {{ numberWithCommas(finalDebit) }}
              </td>
              <td class="has-text-right">
                <span class="mdi mdi-currency-inr" v-if="finalCredit"></span>

                {{ numberWithCommas(finalCredit) }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </section>
    <br />

    <br />
    <!-- print order invoice-->
    <div class="" v-if="franchisee && invoiceDetail.products.length">
      <OrderInvoice :invoiceDetail="invoiceDetail" :franchisee="franchisee" />
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import Utils from '@/utils'
import _ from 'lodash'
import { mapGetters } from 'vuex'
import ExportUtility from '@/utils/exportUtility'
import constants from '@/utils/constants'
import OrderInvoice from '@/components/OrderInvoice'

export default {
  name: 'ledgerDetail',
  // props: ['franchiseeID'],
  components: {
    OrderInvoice
  },
  data () {
    const date = new Date().getFullYear()
    return {
      companyId: null,
      fromDate: null,
      toDate: null,
      franchiseeTransaction: [],
      inProgress: false,
      companyName: null,
      startBalance: null,
      toggleFilter: false,
      isPagination: false,
      isLoading: false,
      totalDebit: 0,
      franchiseeID: '',
      totalCredit: 0,
      ClosingBalance: 0,
      ClosingBalance1: 0,
      finalDebit: '',
      finalCredit: '',
      currentFY: '',
      selectedFranchisee: '',
      loadingComponent: null,
      allacademicYears: [],
      academicYearID: '',
      Year: Number(date),
      minDate: null,
      maxDate: null,
      invoiceDetail: {
        orderID: this.$route.params.orderID,
        products: [],
        warehouse: {},
        grandTotal: 0,
        displayIGST: false,
        totalIGSTAmount: 0,
        totalSGSTAmount: 0,
        totalCGSTAmount: 0
      }
    }
  },
  watch: {
    franchisee: async function (val, oldVal) {
      await this.onFranchiseeChange()
    },
    academicYear: async function (val) {
      await this.onFranchiseeChange()
    }
  },
  created: async function () {
    await this.onFranchiseeChange()
  },
  computed: {
    ...mapGetters({
      franchisee: 'getFranchisee',
      academicYear: 'getAcademicYear'
    })
  },
  methods: {
    onFranchiseeChange: async function () {
      if (!this.inProgress) {
        this.inProgress = true
        if (this.franchisee) {
          this.franchiseeID = this.franchisee.id
        } else {
          this.franchiseeID = ''
        }
        if (this.academicYear) {
          this.academicYearID = this.academicYear.id
        } else {
          this.academicYearID = ''
        }
        if (!this.franchiseeID) {
          Utils.helper.openDrawer(this)
        } else { await this.onStart() }

        this.inProgress = false
      }
    },
    onStart: async function () {
      this.getYearIn()
      await this.getAllTransactions()
      await this.getAcademicYears()
    },
    getYearIn: function () {
      if (this.academicYear) {
        console.log('this.academicYearID', this.academicYear)
        this.Year = Number(this.academicYear.academicYear.split('-')[0])

        this.fromDate = moment(`04/01/${this.Year}`).format('YYYY-MM-DD')
        this.toDate = moment(`03/31/${this.Year + 1}`).format('YYYY-MM-DD')
        this.minDate = moment(`04/01/${this.Year}`).format('YYYY-MM-DD')
        this.maxDate = moment(`03/31/${this.Year + 1}`).format('YYYY-MM-DD')
      }
    },
    numberWithCommas: function (value) {
      value = Number(value).toFixed(2)
      return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    },
    changeRouteName: function (route) {
      const routeName = _.find(constants.KIT, obj => {
        if (_.isEqual(obj.id, route)) {
          return obj.route
        }
      })
      return routeName.route
    },
    getAllTransactions: async function () {
      try {
        if (this.academicYear) {
          this.Year = Number(this.academicYear.academicYear.split('-')[0])
        }

        this.loadingComponent = this.$buefy.loading.open()

        let filterObj = {
          franchiseeID: this.franchiseeID
        }
        if (this.franchiseeID) {
          filterObj.from = moment(this.fromDate).format('YYYY-MM-DD')
          filterObj.to = moment(this.toDate).format('YYYY-MM-DD')
        }

        const { data } = await http.get(`${constants.API_URL}/api/payments/franchisee`, {
          params: filterObj
        })

        this.franchiseeTransaction = data.franchiseeTransaction

        this.companyName = data.franchisee.companyName
        this.companyId = data.franchisee.id

        // this.startBalance = data.transaction

        // this.currentFY = '01/04/' + this.Year
        this.toggleFilter = false

        this.franchiseeTransaction.forEach(obj => {
          obj.accountApproveDate = moment(obj.accountApproveDate).format('DD/MM/YYYY')
        })

        let credits = _.sumBy(
          _.filter(this.franchiseeTransaction, item => item.transactionType === 'CREDIT'),
          item => Number(item.amount)
        )
        let debits = _.sumBy(
          _.filter(this.franchiseeTransaction, item => item.transactionType === 'DEBIT'),
          item => Number(item.amount)
        )
        let openingCredit = 0
        let openingDebit = 0
        // if (this.startBalance.openingAmount.type === 'CREDIT') {
        //   openingCredit = Number(this.startBalance.openingAmount.amount)
        // } else {
        //   openingDebit = Number(this.startBalance.openingAmount.amount)
        // }
        this.totalCredit = Number(credits) + Number(openingCredit)
        this.totalDebit = Number(debits) + Number(openingDebit)
        this.ClosingBalance1 = Number(this.totalCredit - this.totalDebit)
        this.ClosingBalance = Math.abs(Number(this.totalCredit - this.totalDebit))

        this.finalDebit = (Number(this.totalDebit) + Number(this.ClosingBalance1)).toFixed(2)
        // this.finalDebit = (Number(this.totalDebit) + Number(this.startBalance.openingAmount.amount)).toFixed(2)
        this.finalCredit = Number(this.totalCredit).toFixed(2)

        this.loadingComponent.close()
      } catch (e) {
        this.loadingComponent.close()
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.toggleFilter = false
        return this.$buefy.dialog.alert({
          message: errorMessage,
          type: 'is-danger',
          hasIcon: true,
          animation: 'zoom-out',
          size: 'is-medium',

          icon: ' mdi-exclamation',
          iconPack: 'mdi',
          ariaRole: 'alertdialog',
          ariaModal: true
        })
      }
    },
    getAcademicYears: async function () {
      try {
        const { data } = await http.get(`${constants.API_URL}/api/franchiseeAcademicYears`)
        this.allacademicYears = data.rows
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        return this.$buefy.dialog.alert({
          type: 'is-danger',
          message: errorMessage,
          hasIcon: true,
          animation: 'zoom-out',
          size: 'is-medium',

          icon: ' mdi-exclamation',
          iconPack: 'mdi',
          ariaRole: 'alertdialog',
          ariaModal: true
        })
      }
    },
    printLedger: function () {
      const printContents = document.getElementById('ledgerPrintableArea').innerHTML
      const documentHead =
        '<!DOCTYPE html><html lang="en"><head><style>@page{margin-top:10px;margin-bottom:0px;}body{margin:0;padding:0;font-family:Consolas,arial;font-size:11px;}.ledgerTable{border:1px solid;box-sizing: border-box;border-collapse: collapse;}.ledgerTable td, th{border-right:1px solid;border-bottom:1px solid;box-sizing: border-box;vertical-align:top;text-align:right;}.ledgerTable td.noBorder{border:none;}</style></head><body>' +
        printContents +
        '</body></html>'
      const doc = document.getElementById('iframeLedger').contentWindow.document
      doc.open()
      doc.write(documentHead)
      window.frames['iframeLedger'].focus()
      window.frames['iframeLedger'].print()
      doc.removeChild(doc.documentElement)
    },
    exportToCSV: function () {
      const csvData = []
      this.franchiseeTransaction.forEach((t, index) => {
        csvData.push({
          SRNo: index + 1,
          Date: t.accountApproveDate,
          '': t.transactionType === 'CREDIT' ? 'Dr' : 'Cr',
          Particulars: t.transactionDescription,
          voucherType: t.voucherType,
          Debit: t.transactionType === 'DEBIT' ? t.amount : '',
          Credit: t.transactionType === 'CREDIT' ? t.amount : ''
        })
      })
      csvData.push({
        SRNo: '',
        Date: '',
        '': '',
        Particulars: '',
        voucherType: '',
        Debit: this.totalDebit,
        Credit: this.totalCredit
      })
      csvData.push({
        SRNo: '',
        Date: '',
        '': Number(this.ClosingBalance) > 0 ? 'Dr' : 'Cr',
        Particulars: 'Closing Balance',
        voucherType: '',
        Debit: this.ClosingBalance,
        Credit: ''
      })
      csvData.push({
        SRNo: '',
        Date: '',
        '': '',
        Particulars: '',
        voucherType: '',
        Debit: this.finalDebit,
        Credit: this.finalCredit
      })
      ExportUtility.convertToCsv(csvData, this.academicYearID)
    },
    printInvoice: async function (orderID) {
      await this.getOrderDetails(orderID)
      if (!this.invoiceDetail.products.length) return
      const printContents = await document.getElementById('printableArea').innerHTML
      const documentHead =
        '<!DOCTYPE html><html lang="en"><head><style>@page{margin-top:10px;margin-bottom:0px;}body{margin:0;padding:0;font-family:Consolas,arial;font-size:11px;}.invoiceTable{border:1px solid;box-sizing: border-box;border-collapse: collapse;}.invoiceTable td,th{border-right:1px solid;border-bottom:1px solid;box-sizing: border-box;vertical-align:top;text-align:right;}.invoiceTable td.noBorder{border:none;}.franchiseeTable{line-height: 1.5}</style></head><body>' +
        printContents +
        '</body></html>'
      const doc = document.getElementById('iframeReceipt').contentWindow.document
      doc.open()
      doc.write(documentHead)
      window.frames['iframeReceipt'].focus()
      window.frames['iframeReceipt'].print()
      doc.removeChild(doc.documentElement)
    },
    getOrderDetails: async function (orderID) {
      try {
        this.invoiceDetail.products = []
        this.loadingComponent = this.$buefy.loading.open()

        const { data } = await http.get(`${constants.API_URL}/api/order/details/${orderID}`, {
          params: {
            franchiseeID: this.franchiseeID
          }
        })

        this.orderData = data
        if (!data.orderDetails) {
          this.loadingComponent.close()
          return this.$buefy.dialog.alert({
            message: 'No Order Details Found',
            type: 'is-danger',
            hasIcon: true,
            animation: 'zoom-out',
            size: 'is-medium',
            icon: ' mdi-exclamation',
            iconPack: 'mdi',
            ariaRole: 'alertdialog',
            ariaModal: true
          })
        } else {
          await this.getFranchiseeDetail()
        }
        data.orderTime = new Date(data.orderTime)
        data.orderTime = data.orderTime.toLocaleDateString()

        this.invoiceDetail.products = this.orderData ? this.orderData.orderDetails : []
        this.invoiceDetail.orderDate = data.orderTime

        this.loadingComponent.close()
      } catch (e) {
        this.loadingComponent.close()
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        console.log('Error While Fetching Order details', errorMessage)
        return this.$buefy.dialog.alert({
          message: errorMessage,
          type: 'is-danger',
          hasIcon: true,
          animation: 'zoom-out',
          size: 'is-medium',

          icon: ' mdi-exclamation',
          iconPack: 'mdi',
          ariaRole: 'alertdialog',
          ariaModal: true
        })
      }
    },
    getFranchiseeDetail: async function () {
      try {
        const { data } = await http.get(`${constants.API_URL}/api/payments/franchisee/${this.orderData.franchiseeID}`)
        this.franchisee = data
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        console.log('e :', errorMessage)
      }
    }
  }
}
</script>

<style media="screen">
.sticky {
  top: 46px;
  z-index: 10;
  opacity: 1;
  background-color: #fff;
  position: -webkit-sticky;
  position: sticky;
  box-shadow: 0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 1px 5px 0 rgba(0, 0, 0, 0.12);
}
</style>
